export enum ModalId {
  ChatLocationHelpPopover = 'chat-location-help-popover',
  FileTransfer = 'file-transfer',
  Troubleshooting = 'troubleshooting',
  VirtualBackground = 'virtual-background',
  CallSettings = 'call-settings',
  Screenshare = 'screenshare',
  Extension = 'extension',
  AddToGroupCall = 'add-to-group-call',
  InviteViaEmail = 'invite-via-email',
  InviteViaTextMessage = 'invite-via-text-message',
  ChangePassword = 'change-password',
  ChangeEmailAddress = 'change-email-address',
  ChangeRole = 'change-role',
  DeleteAccount = 'delete-account',
  ProfilePicture = 'profile-picture',
  TermsOfService = 'terms-of-service',
  UpgradeSubscription = 'upgrade-subscription',
  MarketingModal = 'marketing-modal',
  PhotoCaptureConsent = 'photo-capture-consent',
  AccountSidebar = 'account-sidebar',
  CustomWaitingRoomHeadshot = 'custom-waiting-room-headshot',
  PauseCall = 'pause-call',
  CreateRoomModal = 'create-room-modal',
  PatientTransfer = 'patient-transfer',
  DisableUser = 'disable-user',
  EnableUser = 'enable-user',
  RemoveUser = 'remove-user',
  InviteUsers = 'invite-users',
  InviteUserWithAccountCreation = 'invite-user-with-account-creation',
}

export type ModalsSliceState = {
  current: ModalId | null;
  triggerElementId: string | null;
};
